import React from 'react'
import { TextInput } from '../Inputs';

export const DateInput = (props) => (
    <TextInput {...props} type={"date"} />
)
